export default "__VITE_ASSET__f5586deb__"